import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { useEffect, useState } from "react";
import { BP } from "../../../util/constants/breakpoints";

export default function AboutMeHero() {

    const smallest = 24;
    const mobileHeaderEmojiWidth = 36;
    const desktopHeaderEmojiWidth = 52;

    const [headerEmojiWidth, setHeaderEmojiWidth] = useState(mobileHeaderEmojiWidth);

    const onWindowWidthChange = () => {
        setHeaderEmojiWidth(getHeaderEmojiWidth())
    }

    const getHeaderEmojiWidth = () => {

        if(window.innerWidth < BP.xs) return smallest;

        if(window.innerWidth < BP.sm) return mobileHeaderEmojiWidth 
        else return desktopHeaderEmojiWidth 
    }


    useEffect(() => {
        setHeaderEmojiWidth(getHeaderEmojiWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <div 
                className="
                    bg-body-bg-light 
                    dark:bg-body-bg-dark
                    w-screen 
                    h-screen
                    flex
                    flex-col
                    justify-center
                    items-center
                    gap-y-2.5
                    sm:gap-y-7
                "
            >
                <h2
                    className="
                        text-2xl
                        xs:text-3xl
                        sm:text-5xl
                        text-body-text-light
                        dark:text-body-text-dark
                        tracking-widest
                        font-bold

                        flex
                        items-center
                    "
                >
                    Bringing ideas to life!&nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="sparkles" width={headerEmojiWidth}/>
                    </EmojiProvider>
                </h2>
            </div>
        </>
    );

}